<template>
    <div class="menu-plataforma" id="menu-lateral-int" v-sideBar="MenuVisivel">
        <div class="paiTituloMenuinterativo">
            <i class="fas fa-tv iconeTituloMenuInterativo"></i>
            <div class="tituloMenuInterativo">Menu Interativo</div>
            <div class="linhaMenuInterativo"></div>
        </div>
        <div class="paiItemMenuinterativo" @click="goDashboard">
            <i class="fas fa-tachometer-alt iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Dashboard</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goBateria">
            <i class="fas fa-battery-three-quarters iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Baterias</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goColaborador" v-if="usuario.admin">
            <i class="far fa-id-card iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Colaboradores</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goFrota" v-if="usuario.admin">
            <i class="fas fa-tractor iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Frota</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goOperacao" v-if="usuario.admin">
            <i class="fas fa-tools iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Eficiência da Operação</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goFinanca" v-if="usuario.admin">
            <i class="fas fa-hand-holding-usd iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Aquisições e Finanças</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goSuporte">
            <i class="far fa-question-circle iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Suporte</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goAdm" v-if="usuario.admin">
            <i class="fas fa-cogs iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Administração</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goCadastHion" v-if="usuario.admin">
            <i class="fas fa-restroom iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Cadastro Hion</div>
        </div>
        <div class="paiItemMenuinterativo" @click="goCadastCliente" v-if="usuario.admin">
            <i class="fas fa-people-arrows iconeItemMenuInterativo"></i>
            <div class="textoItemMenuInterativo">Cadastro Clientes</div>
        </div>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { mapState } from 'vuex'
//import axios from 'axios'

export default {
    name: 'MenuInterativo',
    components: { },
    computed: {
        ...mapState(['MenuVisivel', 'usuario']),
        
    },
    directives: {
			sideBar: {
				inserted: function (el) {
                    //fecha menu small caso a tela seja XS
                    if(window.innerWidth <= 575) el.classList.add("esconde-menu-plataforma");
                },
				update: function (el, binding) {

                    if (!binding.value) {
                        for (let i = 0; i < el.children.length; i++) {
                            let fadeTarget = el.children[i];
                            fadeTarget.style.transition="opacity 0.5s";
                            fadeTarget.style.opacity="0";
                        }
                        setTimeout(function(){
                            el.classList.add("esconde-menu-plataforma");
                        }, 500);
                    } else {
                        el.classList.remove("esconde-menu-plataforma");
                        setTimeout(function(){
                            for (let i = 0; i < el.children.length; i++) {
                                let fadeTarget = el.children[i];
                                fadeTarget.style.transition="opacity 0.5s";
                                fadeTarget.style.opacity="1";
                            }
                        }, 500);
                    }
                }
            }
    },
    methods: {
        goDashboard() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'HomeInterativa' }), 400);
        },
        goBateria() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'BateriaInterativa' }), 400);
        },
        goColaborador() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'ColaboradorInterativo' }), 400);
        },
        goFrota() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'FrotaInterativa' }), 400);
        },
        goOperacao() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'OperacaoInterativa' }), 400);
        },
        goFinanca() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'FinancaInterativa' }), 400);
        },
        goSuporte() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'SuporteInterativo' }), 400);
        },
        goAdm() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'AdminPages' }), 400);
        },
        goCadastHion() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'CadastroHion' }), 400);
        },
        goCadastCliente() {
            VueScrollTo.scrollTo('.header');
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                    this.$store.commit('alternaMenu', false)
            }
            setTimeout( () => this.$router.push({ name: 'CadastroCliente' }), 400);
        }
        //async initMenu() { 
               //await this.$store.dispatch('fechaMenuAsync')
        //}
    },  
    mounted() {
        //this.initMenu();
    }
}
</script>

<style>
.menu-plataforma {
    /*grid-area: mbaeu;*/
    /*background: linear-gradient(to right, #232526, #414345);*/
    background-image: url("../../assets/hion_sideMenu.png");
    background-color: #000;
    /*background-image: linear-gradient(to bottom right, #008fac , #004f5f);*/

    /* Center and scale the image nicely */
    /*background-position: center;*/
    /*background-repeat: no-repeat;*/
    /*background-size: cover;*/
    /*opacity: 0.95;*/

    position: relative;
    height: 100%;
    width: 270px;
    overflow-x: hidden;
    overflow-y: hidden;
    transition-duration: 0.5s, 0.5s, 0.75s;
    transition-property: top, bottom, width;
    transition-timing-function: linear, linear, ease;
}
.esconde-menu-plataforma {
    width: 0px;
}

/* FRONTEND **********************************/

/** CSS do Titulo do Menu */
.paiTituloMenuinterativo {
    display: inline-block;
    padding: 30px 0px 20px 20px
}
.iconeTituloMenuInterativo {
    font-size: 1.5em;
    color: #008fac;
}
.tituloMenuInterativo {
    display: inline;
    padding-left: 20px;
    font-size: 1.3em;
    color: #eee;
    font-family: 'Play';
}
.linhaMenuInterativo{
    background:#fff;
    height: 2px;
    width: 250px;
    left: 10px;
    display: inline-block;
}

/*******Botoes do Menu Interativo *********/
.paiItemMenuinterativo{
    display: inline-block;
    width: 100%;
    height: 50px;
}
.paiItemMenuinterativo:hover {
    background: #008fac;
    opacity: 0.8;
    cursor:pointer;
}
.paiItemMenuinterativo:hover .iconeItemMenuInterativo {
    color: #eee;
}
.paiItemMenuinterativo:hover .textoItemMenuInterativo {
    font-weight: bold;
    color: #ffd618;
}
.iconeItemMenuInterativo {
    font-size: 1.4em;
    color: #ffd618;
    padding: 15px 0px 10px 30px;
}
.textoItemMenuInterativo {
    display: inline;
    padding-left: 15px;
    font-size: 1.em;
    color: #eee;

    padding: 0px 0px 10px 15px;
}

/* BACKGROUND**********************************/




</style>